import { Component, Input } from '@angular/core';

import './alert-message.component.css';

@Component({
    selector: 'ohp-alert-message',
    templateUrl: './alert-message.component.html'
})
export class AlertMessageComponent {
    @Input() public message: string;
}
